import { render, staticRenderFns } from "./LocalArmazenamentoList.vue?vue&type=template&id=2d69e487"
import script from "./LocalArmazenamentoList.vue?vue&type=script&lang=js"
export * from "./LocalArmazenamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports